import { MessagePreviewVideoProps } from "../types"
import React from "react"
import PreviewWrap from "./preview-wrap"
import PreviewText from "./preview-text"

const MessageFile: React.FC<MessagePreviewVideoProps> = ({ forwardPrependMsg }) => {
  return (
    <PreviewWrap>
      <PreviewText>{`${forwardPrependMsg}[文件]`}</PreviewText>
    </PreviewWrap>
  )
}
export default MessageFile
